import React, { useEffect, useState } from "react";
import { node, string, bool } from "prop-types";

export const AccordionContext = React.createContext();

const Accordion = ({ className, children, expandAll, numberToExpand }) => {
    const [itemOpen, setItemOpen] = useState(null);

    const clearItemOpen = () => {
        setItemOpen(null);
    };

    useEffect(() => {
        if (expandAll !== null) {
            clearItemOpen();
        }
    }, [expandAll]);

    useEffect(() => {
        if (numberToExpand !== null) {
            clearItemOpen();
        }
    }, [numberToExpand]);

    const handleClick = (number) => {
        if (number === itemOpen) {
            setItemOpen(null);
        } else {
            setItemOpen(number);
        }
    };

    return (
        <AccordionContext.Provider value={{ itemOpen, onClick: handleClick, expandAll, numberToExpand }}>
            <ul className={`accordion ${className}`}>{children}</ul>
        </AccordionContext.Provider>
    );
};

Accordion.propTypes = {
    children: node.isRequired,
    className: string,
    expandAll: bool,
    numberToExpand: string,
};

Accordion.defaultProps = {
    className: "navigational-list",
    expandAll: null,
    numberToExpand: null,
};

export default Accordion;
